import styled from 'styled-components';
import { FormControl } from '@material-ui/core';

// CONSTANTS
import { MAIN_BLACK, SANTAS_GRAY, GRAY_SUIT } from '@/constants/colors';

// UTILITY
import { breakpoints } from '@/utility/breakpoints';

export const StyledAmountField = styled.div`
  label {
    color: ${MAIN_BLACK};
    margin-bottom: 8px;
  }

  .MuiInputBase-input {
    padding-top: 1.35rem;
    padding-bottom: 1.35rem;

    &::placeholder {
      color: ${SANTAS_GRAY};
    }
  }
`;

export const StyledTransMethodField = styled(FormControl)`
  .MuiFormLabel-root {
    color: ${MAIN_BLACK};

    display: flex;
    align-items: center;

    margin-bottom: 13px;
  }

  .type {
    &__label {
      margin-left: -7px;

      .MuiRadio-root .MuiSvgIcon-root,
      .info-icon {
        width: 20px;
        height: 20px;
      }

      .info-icon {
        margin-left: 10px;

        color: ${SANTAS_GRAY};
      }

      .MuiIconButton-root {
        padding: 10px;
      }

      .MuiTypography-root {
        display: flex;
        align-items: center;

        margin-left: 7px;

        font-size: 1.6rem;
        line-height: 1.6rem;
        font-weight: 600;
      }

      .type__label--checked {
        .MuiTypography-root {
          color: ${({ theme }) => theme.palette.primary.main};
        }
      }
    }
  }

  ${breakpoints.up('md')} {
    .type__label {
      .MuiIconButton-root {
        padding: 7px;
      }
    }
  }

  &.type-field--large {
    .type__label {
      position: relative;
      margin-left: 0;
      padding: 34px;
      border-radius: 16px;
      border: 1px solid ${GRAY_SUIT};

      .info-icon {
        position: absolute;

        margin-left: 0;

        top: 18px;
        right: 18px;
      }

      .MuiIconButton-root {
        padding-top: 0;
        padding-bottom: 0;
        padding-left: 0;
      }

      &.type__label--checked {
        border-color: ${({ theme }) => theme.palette.primary.main};
      }

      & + .type__label {
        margin-top: 16px;
      }
    }
  }
`;

export const StyledFundsForm = styled.div`
  .amount-field {
    margin-bottom: 32px;
  }

  .type-field {
    margin-bottom: 24px;
  }

  .alert-error {
    margin-top: 16px;
  }

  .funds-form {
    &__buttons {
      margin-top: 32px;

      height: 44px;

      display: flex;
    }

    &__back {
      min-width: 110px;

      margin-right: 10px;
    }

    &__submit {
      width: 100%;
    }
  }

  &.funds-form--dialog {
    .amount .MuiInputBase-root {
      border-radius: 10px;
    }

    .type-field__label {
      margin-bottom: 3px;
    }

    .type__label {
      margin-left: -7px;
    }

    .amount-field,
    .type-field {
      margin-bottom: 20px;
    }

    .credit-card__label {
      margin-bottom: 10px;
    }

    .funds-form {
      &__buttons {
        margin-top: 25px;

        button {
          border-radius: 74px;
        }
      }
    }
  }
`;

export default StyledFundsForm;
